// import React, { useEffect, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
//   Box,
//   TextField,
//   MenuItem,
//   CircularProgress,
//   Typography,
// } from "@mui/material";
// import { EditOutlined } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import { adminService } from "../services/adminService";
// import {
//   primaryDark,
//   accentColor,
//   buttonGradient,
//   buttonGradientHover,
// } from "../../../constants/consts";

// const popIn = keyframes`
//   from { opacity: 0; transform: scale(0.92); }
//   to   { opacity: 1; transform: scale(1); }
// `;

// export default function SupportEditDialog({
//   open,
//   support,
//   onClose,
//   onSaved,
//   sunucuKoduList = [],
//   personelList = [],
// }) {
//   const [form, setForm] = useState({
//     title: "",
//     sunucuKodu: "",
//     personel: "",
//     userId: null,
//   });
//   const [usersList, setUsersList] = useState([]);
//   const [saving, setSaving] = useState(false);
//   const [loadingUsers, setLoadingUsers] = useState(false);
//   const [error, setError] = useState("");

//   /* Başlangıç değerleri */
//   useEffect(() => {
//     if (open && support) {
//       setForm({
//         title: support.title ?? "",
//         sunucuKodu: support.sunucuKodu ?? "",
//         personel: support.supporter ?? "",
//         userId: support.userId ?? null,
//       });
//       setError("");
//       // Sunucu seçili ise kullanıcıları çek
//       if (support.sunucuKodu) loadUsers(support.sunucuKodu);
//     }
//     // eslint-disable-next-line
//   }, [open, support]);

//   const loadUsers = async (sunucuKodu) => {
//     if (!sunucuKodu) {
//       setUsersList([]);
//       return;
//     }
//     setLoadingUsers(true);
//     try {
//       const [users, rootUsers] = await Promise.all([
//         adminService.getUsersByType({ type: "user", sunucuKodu }),
//         adminService.getUsersByType({ type: "rootUser", sunucuKodu }),
//       ]);
//       setUsersList([...users, ...rootUsers]);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       setLoadingUsers(false);
//     }
//   };

//   const handleChange = (k) => (e) => {
//     const v = e.target.value;
//     setForm((prev) => ({ ...prev, [k]: v }));
//     if (k === "sunucuKodu") {
//       setForm((prev) => ({ ...prev, userId: null }));
//       loadUsers(v);
//     }
//   };

//   const handleSave = async () => {
//     if (
//       !form.title.trim() ||
//       !form.sunucuKodu ||
//       !form.personel ||
//       form.userId == null
//     ) {
//       setError("Tüm alanlar zorunludur.");
//       return;
//     }
//     setSaving(true);
//     setError("");
//     try {
//       await adminService.updateSupport({
//         supportId: support.id,
//         userId: Number(form.userId),
//         title: form.title.trim(),
//         sunucuKodu: form.sunucuKodu,
//         personel: form.personel,
//       });
//       onSaved?.();
//       onClose?.();
//     } catch (e) {
//       console.error(e);
//       setError("Güncelleme başarısız.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   return (
//     <Dialog
//       open={open}
//       onClose={onClose}
//       fullWidth
//       maxWidth="sm"
//       PaperProps={{
//         sx: {
//           borderRadius: 3,
//           animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
//           overflow: "hidden",
//         },
//       }}
//     >
//       <Box
//         sx={{
//           px: 3,
//           py: 1.75,
//           background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
//         }}
//       >
//         <DialogTitle
//           sx={{
//             p: 0,
//             color: "#fff",
//             fontWeight: 700,
//             display: "flex",
//             alignItems: "center",
//             gap: 1,
//           }}
//         >
//           <EditOutlined sx={{ fontSize: 20 }} />
//           Destek Talebini Düzenle
//         </DialogTitle>
//       </Box>

//       <DialogContent sx={{ pt: 3 }}>
//         <Box
//           sx={{
//             display: "grid",
//             gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
//             gap: 2,
//           }}
//         >
//           <TextField
//             label="Konu *"
//             value={form.title}
//             onChange={handleChange("title")}
//             fullWidth
//             size="small"
//             sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
//           />
//           <TextField
//             label="Sunucu Kodu *"
//             value={form.sunucuKodu}
//             onChange={handleChange("sunucuKodu")}
//             select
//             fullWidth
//             size="small"
//           >
//             {sunucuKoduList.map((s) => (
//               <MenuItem key={s} value={s}>
//                 {s}
//               </MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             label="Destek Personeli *"
//             value={form.personel}
//             onChange={handleChange("personel")}
//             select
//             fullWidth
//             size="small"
//           >
//             {personelList.map((p) => (
//               <MenuItem key={p} value={p}>
//                 {p}
//               </MenuItem>
//             ))}
//           </TextField>
//           <TextField
//             label="Destek İsteyen Kullanıcı *"
//             value={form.userId ?? ""}
//             onChange={handleChange("userId")}
//             select
//             fullWidth
//             size="small"
//             disabled={!form.sunucuKodu || loadingUsers}
//             sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
//             helperText={
//               loadingUsers
//                 ? "Kullanıcılar yükleniyor…"
//                 : !form.sunucuKodu
//                   ? "Önce sunucu kodu seçin"
//                   : ""
//             }
//           >
//             {usersList.map((u) => (
//               <MenuItem key={u.id} value={u.id}>
//                 {u.username}
//               </MenuItem>
//             ))}
//           </TextField>
//         </Box>

//         {error && (
//           <Typography
//             sx={{ mt: 2, color: "#B91C1C", fontSize: 12.5, fontWeight: 600 }}
//           >
//             {error}
//           </Typography>
//         )}
//       </DialogContent>

//       <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
//         <Button
//           onClick={onClose}
//           variant="outlined"
//           sx={{ textTransform: "none", borderRadius: 2 }}
//         >
//           Vazgeç
//         </Button>
//         <Button
//           onClick={handleSave}
//           disabled={saving}
//           variant="contained"
//           sx={{
//             textTransform: "none",
//             borderRadius: 2,
//             fontWeight: 700,
//             background: buttonGradient,
//             "&:hover": { background: buttonGradientHover },
//             "&:disabled": { background: "#c7c7c7" },
//           }}
//         >
//           {saving ? (
//             <CircularProgress size={20} sx={{ color: "#fff" }} />
//           ) : (
//             "Kaydet"
//           )}
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// }
import React, { useEffect, useMemo, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Autocomplete,
  CircularProgress,
  Typography,
} from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { adminService } from "../services/adminService";
import {
  primaryDark,
  accentColor,
  buttonGradient,
  buttonGradientHover,
} from "../../../constants/consts";

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.92); }
  to   { opacity: 1; transform: scale(1); }
`;

const normalize = (s = "") => String(s).toLocaleLowerCase("tr-TR").trim();

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: 2,
    transition: "box-shadow 0.25s ease, background-color 0.25s ease",
    "&:hover": { backgroundColor: "rgba(4,87,129,0.02)" },
    "&.Mui-focused": {
      boxShadow: "0 0 0 4px rgba(4,87,129,0.10)",
    },
  },
};

export default function SupportEditDialog({
  open,
  support,
  onClose,
  onSaved,
  sunucuKoduList = [],
  personelList = [],
}) {
  const [form, setForm] = useState({
    title: "",
    sunucuKodu: "",
    personel: "",
    userId: null,
  });
  const [usersList, setUsersList] = useState([]);
  const [saving, setSaving] = useState(false);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [error, setError] = useState("");

  /* Başlangıç değerleri */
  useEffect(() => {
    if (open && support) {
      setForm({
        title: support.title ?? "",
        sunucuKodu: support.sunucuKodu ?? "",
        personel: support.supporter ?? "",
        userId: support.userId ?? null,
      });
      setError("");
      if (support.sunucuKodu) loadUsers(support.sunucuKodu);
    }
    // eslint-disable-next-line
  }, [open, support]);

  const loadUsers = async (sunucuKodu) => {
    if (!sunucuKodu) {
      setUsersList([]);
      return;
    }
    setLoadingUsers(true);
    try {
      const [users, rootUsers] = await Promise.all([
        adminService.getUsersByType({ type: "user", sunucuKodu }),
        adminService.getUsersByType({ type: "rootUser", sunucuKodu }),
      ]);
      setUsersList([...users, ...rootUsers]);
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleSunucuChange = (v) => {
    setForm((prev) => ({ ...prev, sunucuKodu: v || "", userId: null }));
    if (v) loadUsers(v);
    else setUsersList([]);
  };

  const selectedUser =
    usersList.find((u) => String(u.id) === String(form.userId)) || null;

  const filterFn = useMemo(
    () =>
      (options, { inputValue }) => {
        const q = normalize(inputValue);
        return options.filter((opt) => {
          if (typeof opt === "string") return normalize(opt).includes(q);
          // User objeleri için
          return normalize(opt.username).includes(q);
        });
      },
    [],
  );

  const handleSave = async () => {
    if (
      !form.title.trim() ||
      !form.sunucuKodu ||
      !form.personel ||
      form.userId == null
    ) {
      setError("Tüm alanlar zorunludur.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await adminService.updateSupport({
        supportId: support.id,
        userId: Number(form.userId),
        title: form.title.trim(),
        sunucuKodu: form.sunucuKodu,
        personel: form.personel,
      });
      onSaved?.();
      onClose?.();
    } catch (e) {
      console.error(e);
      setError("Güncelleme başarısız.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: 3,
          animation: `${popIn} 0.25s cubic-bezier(0.22, 1, 0.36, 1) both`,
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 1.75,
          background: `linear-gradient(135deg, ${primaryDark} 0%, ${accentColor} 100%)`,
        }}
      >
        <DialogTitle
          sx={{
            p: 0,
            color: "#fff",
            fontWeight: 700,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <EditOutlined sx={{ fontSize: 20 }} />
          Destek Talebini Düzenle
        </DialogTitle>
      </Box>

      <DialogContent sx={{ pt: 3 }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 2,
          }}
        >
          {/* Konu */}
          <TextField
            label="Konu *"
            value={form.title}
            onChange={(e) =>
              setForm((prev) => ({ ...prev, title: e.target.value }))
            }
            fullWidth
            size="small"
            sx={{
              ...inputSx,
              gridColumn: { xs: "1", sm: "1 / span 2" },
            }}
          />

          {/* Sunucu Kodu */}
          <Autocomplete
            size="small"
            options={sunucuKoduList}
            value={form.sunucuKodu || null}
            onChange={(_, v) => handleSunucuChange(v)}
            filterOptions={filterFn}
            noOptionsText="Sunuçu bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Sunucu Kodu *"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          {/* Personel */}
          <Autocomplete
            size="small"
            options={personelList}
            value={form.personel || null}
            onChange={(_, v) =>
              setForm((prev) => ({ ...prev, personel: v || "" }))
            }
            filterOptions={filterFn}
            noOptionsText="Personel bulunamadı"
            renderInput={(params) => (
              <TextField
                {...params}
                label="Destek Personeli *"
                placeholder="Yaz veya seç"
                sx={inputSx}
              />
            )}
          />

          {/* Destek İsteyen Kullanıcı */}
          <Autocomplete
            size="small"
            options={usersList}
            value={selectedUser}
            onChange={(_, v) =>
              setForm((prev) => ({
                ...prev,
                userId: v ? v.id : null,
              }))
            }
            loading={loadingUsers}
            getOptionLabel={(opt) => opt?.username || ""}
            filterOptions={filterFn}
            isOptionEqualToValue={(a, b) => String(a?.id) === String(b?.id)}
            noOptionsText={
              !form.sunucuKodu
                ? "Önce sunucu kodu seçin"
                : loadingUsers
                  ? "Yükleniyor…"
                  : "Kullanıcı bulunamadı"
            }
            disabled={!form.sunucuKodu || loadingUsers}
            sx={{ gridColumn: { xs: "1", sm: "1 / span 2" } }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Destek İsteyen Kullanıcı *"
                placeholder={
                  !form.sunucuKodu ? "Önce sunucu kodu seçin" : "Yaz veya seç"
                }
                sx={inputSx}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loadingUsers && (
                        <CircularProgress size={16} sx={{ mr: 1 }} />
                      )}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                }}
              />
            )}
          />
        </Box>

        {error && (
          <Typography
            sx={{ mt: 2, color: "#B91C1C", fontSize: 12.5, fontWeight: 600 }}
          >
            {error}
          </Typography>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          sx={{ textTransform: "none", borderRadius: 2 }}
        >
          Vazgeç
        </Button>
        <Button
          onClick={handleSave}
          disabled={saving}
          variant="contained"
          sx={{
            textTransform: "none",
            borderRadius: 2,
            fontWeight: 700,
            background: buttonGradient,
            "&:hover": { background: buttonGradientHover },
            "&:disabled": { background: "#c7c7c7" },
          }}
        >
          {saving ? (
            <CircularProgress size={20} sx={{ color: "#fff" }} />
          ) : (
            "Kaydet"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
